export enum LocalStorageEnum {
  token = '_t',
  token_expires_at = '_tea',
  user_id = '_u',
  user_profile = '_uf',
  user_firstname = '_ufn',
  user_lastname = '_uln',
  username = '_un',
  user_role = '_ur',
  user_role_code = '_urc',
  user_role_group = '_urg',
  user_role_name = '_urn',
  refresh_token = '_rft',
  permissions = '_up',
  lang = 'lang',
  current_scheme = '_cs',
  current_scheme_code = '_csc',
  investment_fund_status_tab = '_it',
}
